var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmbience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4384",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H31.4999V32H0.5V1Z",
    fill: "white",
    stroke: "#BC172F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4575 16.2514C21.0652 12.9434 18.4276 8.93642 13.6824 7.32117C13.4277 7.23448 13.1731 7.44635 13.2128 7.71242C13.2984 8.28655 13.3288 8.99867 13.1774 9.78299C12.9579 10.9201 12.5141 11.3922 12.1108 12.3691C11.593 13.6237 11.2543 15.4376 11.6391 16.7978C12.4713 19.7391 16.7127 20.6581 17.03 20.7227C17.782 20.2595 19.9969 18.7594 20.4575 16.2514Z",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4598 25.6992C16.1507 24.2914 17.4243 21.1987 17.0833 17.1958C16.8587 14.5595 16.0177 12.5157 15.3734 11.2571",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0569 13.0997C18.0557 13.4153 18.0083 14.0727 17.5969 14.7438C17.3603 15.1299 17.0816 15.3925 16.8734 15.557",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0483 15.0253C14.5793 15.2806 15.2489 15.6689 15.9324 16.2559C16.4332 16.6861 16.8215 17.1198 17.1157 17.4976",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2648 1.20087C16.9964 0.54856 20.9225 1.26443 24.2241 3.34969C24.4991 3.52349 24.8594 3.4785 25.09 3.24756L26.4204 1.91494C26.8612 1.47331 27.6158 1.78231 27.6158 2.40532L27.6215 8.03031C27.6219 8.417 27.3076 8.73181 26.9202 8.73274L21.2873 8.74437C20.6639 8.74575 20.3518 7.99369 20.7932 7.55149L21.8732 6.46962C22.2058 6.1365 22.125 5.57431 21.7081 5.35825C16.9724 2.90325 10.9775 3.68425 7.0349 7.69401C4.37841 10.3964 3.20647 14.0299 3.51942 17.5517C3.55903 17.9973 3.40428 18.439 3.08716 18.7566C2.19034 19.655 0.651474 19.109 0.537162 17.8488C0.13835 13.4484 1.60998 8.90481 4.95366 5.53906C6.73342 3.74719 8.84572 2.48188 11.0948 1.74356",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.535 21.4501C28.6003 18.9363 28.8253 16.115 28.1486 13.4532C28.0189 12.9425 28.168 12.4 28.5417 12.0257C29.3616 11.2044 30.7656 11.5788 31.051 12.699C32.5304 18.5058 30.5483 24.9232 25.5203 28.8059C19.6673 33.3247 11.5848 32.9941 6.13956 28.4485C5.89005 28.2405 5.52736 28.237 5.26842 28.4359L3.77517 29.5831C3.27992 29.9631 2.57362 29.5578 2.65487 28.9397L3.3893 23.3595C3.43999 22.9755 3.7928 22.7048 4.17704 22.7547L9.75911 23.4827C10.3772 23.5634 10.5868 24.3499 10.0921 24.7303L8.8793 25.6619C8.50536 25.949 8.51224 26.5173 8.8968 26.7859C13.2656 29.8426 19.308 29.8551 23.7408 26.3949C24.8493 25.5299 25.7718 24.5111 26.5021 23.3911",
    stroke: "#BC172F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbience);
export default __webpack_public_path__ + "static/media/ambience.70d5868618d16ebbf0bd49352cba317e.svg";
export { ForwardRef as ReactComponent };